const flattenConnection = (connection: { edges: any[] }): any[] => {
  return connection && connection.edges
    ? connection.edges.map((edge) => edge.node)
    : []
}

export default flattenConnection
